module.exports = __webpack_public_path__ + "static/Lato-Italic-4ffc48d0549568bb624b9ef9c1cf2626.ttf";